.wrap { display: flex; flex-direction: column; gap: 16px; }

.meta {
  display: flex; flex-wrap: wrap; gap: 8px 20px; align-items: baseline;
  font-size: 12px; color: var(--ink-muted, #6b7280);
}
.meta b { color: var(--ink, #111827); font-weight: 600; }

/* Was a yellow notice strip above the card. The notice boxes are gone from
   every page, and this is the last of them; the text stays, demoted to a foot
   note under the table it qualifies, where the basis it names is already in
   the GMV column header. */
.basis {
  padding: 2px 2px 0; font-size: 11.5px; line-height: 1.55;
  color: var(--ink-muted, #6b7280); border-top: 1px solid var(--line, #eef0f3);
  padding-top: 10px; margin-top: 2px;
}
.basis b { color: var(--ink, #111827); font-weight: 600; }

.grid { width: 100%; border-collapse: collapse; font-size: 13px; }
.grid th, .grid td { padding: 7px 10px; border-bottom: 1px solid var(--line, #eef0f3); text-align: left; }
.grid th { font-size: 11px; letter-spacing: .04em; text-transform: uppercase; color: var(--ink-muted, #6b7280); font-weight: 600; }
.grid td.num, .grid th.num { text-align: right; }
.subhead td { background: var(--bg-subtle, #f8fafc); font-weight: 600; color: var(--ink, #111827); }

.input {
  width: 100%; max-width: 150px; padding: 5px 8px; text-align: right;
  border: 1px solid var(--line, #dfe3e8); border-radius: 6px;
  font: inherit; font-variant-numeric: tabular-nums; background: #fff; color: inherit;
}
.input:focus { outline: 2px solid #2f6fed33; border-color: #2f6fed; }
.input.dirty { border-color: #2f6fed; background: #f5f9ff; }
.input.bad { border-color: #d64545; background: #fdf3f3; }

.derived { font-size: 11px; color: var(--ink-muted, #9aa3af); font-variant-numeric: tabular-nums; }

.foot { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; justify-content: space-between; }
.actions { display: flex; gap: 10px; align-items: center; }
.note {
  flex: 1 1 260px; min-width: 200px; padding: 7px 10px; font: inherit;
  border: 1px solid var(--line, #dfe3e8); border-radius: 6px; background: #fff; color: inherit;
}
.btn {
  padding: 8px 16px; border-radius: 6px; border: 1px solid transparent;
  font: inherit; font-weight: 600; cursor: pointer;
  background: #2f6fed; color: #fff;
}
.btn:disabled { opacity: .45; cursor: not-allowed; }
.btnGhost { background: #fff; color: var(--ink, #111827); border-color: var(--line, #dfe3e8); }

.msg { font-size: 12px; }
.ok { color: #1a7f4b; }
.err { color: #d64545; }

.history { font-size: 12px; }
.history table { width: 100%; border-collapse: collapse; }
.history th, .history td { padding: 6px 10px; border-bottom: 1px solid var(--line, #eef0f3); text-align: left; }
.history th { color: var(--ink-muted, #6b7280); font-weight: 600; }

@media (max-width: 700px) {
  .grid th, .grid td { padding: 6px; }
  .input { max-width: 110px; }
}
